<template>
  <div id="contenedor-eliminar-entidad">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Entidad </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar la entidad "{{entidadEliminar.nombre}}"?
        </span>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3">
        </custom-button>
        <custom-button
          @click="mixEliminarEntidad"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar">
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoEntidades from './mixCatalogoEntidades';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoEntidadesEliminar',
  mixins: [mixCatalogoEntidades],
  props: {
    entidadEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">
</style>
